/* eslint-disable react/prop-types */
import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import Colors from '@global/colors';
import { isWeb, isMobileWeb } from '@global/screens';
import { setTitleHeader } from '@global/helpers';
import {
  headerLeftContainerStyle,
  headerBackTitleStyle,
} from '@assets/styles/headerStyles';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';

import ProductCatalogScreen from '@/screens/transaction/catalog/ProductCatalogScreen';
import BrandCatalogScreen from '@/screens/transaction/catalog/BrandCatalogScreen';

const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const BrandCatalogNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();
  return (
    <Stack.Navigator
      initialRouteName="BrandCatalogScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () =>
          isWeb ? <NotificationSettingButton {...props} /> : null,
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        headerStyle: {
          height: 55 + insets.top,
          backgroundColor: Colors.blue1,
        },
        headerTitleAlign: 'left',
        headerTitleStyle: {
          color: isWeb ? 'transparent' : '#FFFFFF',
          fontFamily: 'figtree-medium',
        },
        headerStatusBarHeight: insets.top,
        headerLeftContainerStyle,
        headerBackTitleStyle,
      })}>
      <Stack.Screen
        name="BrandCatalogScreen"
        component={BrandCatalogScreen}
        options={(props) => ({
          title: setTitleHeader('Product Catalog'),
        })}
      />
      <Stack.Screen
        name="ProductCatalogScreen"
        component={ProductCatalogScreen}
        options={(props) => {
          const route = props.route;
          let title = 'Product Catalog';
          if (route.params && route.params.name && !(isWeb && !isMobileWeb)) {
            title = route.params.name;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                onPress={() => props.navigation.navigate('BrandCatalogScreen')}
              />
            ),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default BrandCatalogNavigator;
